exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._17WyMAb7kE3GVOOwb-TpZ2{width:380px}.iji84L-TYfQ1OzoQCLarU{font-size:12px;font-weight:400}html[dir=ltr] .kYi6jPW-Twz-7yNjFuas7 .ms-ContextualMenu-link{padding-left:40px}html[dir=rtl] .kYi6jPW-Twz-7yNjFuas7 .ms-ContextualMenu-link{padding-right:40px}", ""]);
// Exports
exports.locals = {
	"fixWidthContextMenu": "_17WyMAb7kE3GVOOwb-TpZ2",
	"smallFontContextMenu": "iji84L-TYfQ1OzoQCLarU",
	"conditionalPadding": "kYi6jPW-Twz-7yNjFuas7"
};